import React, { FC, useState } from 'react';

import styles from './VaultCard.module.scss';
import VaultCardHeader from './VaultCardHeader/VaultCardHeader';
import VaultCardBody from './VaultCardBody/VaultCardBody';

interface Props {
  vault: any;
}

const VaultCard: FC<Props> = ({ vault }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.card}>
      <VaultCardHeader vault={vault} isExpanded={isExpanded} setIsExpanded={setIsExpanded} />

      {isExpanded && <VaultCardBody vault={vault} />}
    </div>
  );
};

export default VaultCard;
